import UAEventTracking, { ITrackUAEvent } from 'modules/tracking/UAEventTracking';
import { IProductActionTrackingContext } from './types';

const createActionTracking = (
    trackingInfo: IProductActionTrackingContext,
    defaultUAEvent: ITrackUAEvent,
    overrideCallback?: (trackingInfo: IProductActionTrackingContext) => Partial<ITrackUAEvent>
) => {
    let overriddenUAEvent: Partial<ITrackUAEvent> = {
        eventAction: trackingInfo?.eventAction,
        eventCategory: trackingInfo?.eventCategory,
        eventLabel: trackingInfo?.eventLabel
    };

    if (overrideCallback) {
        overriddenUAEvent = overrideCallback(trackingInfo);
    }

    return UAEventTracking({
        eventAction: overriddenUAEvent.eventAction || defaultUAEvent.eventAction,
        eventCategory: overriddenUAEvent.eventCategory || defaultUAEvent.eventCategory,
        eventLabel: overriddenUAEvent.eventLabel || defaultUAEvent.eventLabel
    });
};

export default createActionTracking;
